__webpack_require__.p = "/island-craft-calculator/";